<mat-card class="rounded-3xl border border-slate-200 p-6 shadow-sm">
  <!-- Where the assessment stands -->
  <p class="mb-4 text-sm text-slate-600">
    @if (cia(); as cia) {
      @if (cia.isFinalized) {
        Locked{{ cia.finalizedDate ? ' on ' + (cia.finalizedDate | date: 'medium') : '' }} - no further edits are allowed.
      } @else {
        Draft - what you enter is saved when you move to another step. Locking it needs the risk rating, the clinical impressions, the treatment
        plan summary and the intervention goals, and advances the case to Referral.
      }
    } @else {
      Not started - the assessment is created when you save the first step.
    }
  </p>

  <counselling-intake-assessment-form
    [part]="part()"
    [readOnly]="readOnly()"
    [initialValue]="cia()"
    [lookups]="lookupStore.lookups()"
    [interventionId]="interventionId()"
    [riskScreener]="latestScreener()"
    (submitted)="onSubmitted($event)" />

  <!-- What belongs to the part but is not the assessment's own (the treatment goals sit here, in Treatment planning) -->
  <div class="mt-6 empty:hidden"><ng-content /></div>

  @if (!readOnly()) {
    <div class="mt-6 flex flex-wrap items-center justify-end gap-3 border-t border-slate-200 pt-4">
      @if (part() === 'treatment') {
        <p class="mr-auto text-sm text-slate-600">
          Clinical assessment outcome:
          <span class="font-semibold text-slate-900">{{ subStatus() ?? 'Assessment in progress' }}</span>
        </p>
      }
      <button mat-stroked-button type="button" [disabled]="store.savingCia()" (click)="saveDraft()">Save draft</button>
      @if (part() === 'treatment' && cia()) {
        <button mat-flat-button type="button" [disabled]="store.savingCia()" (click)="lock()">Lock assessment and advance to referral</button>
      }
    </div>
  } @else if (cia()?.isFinalized && canUpdate() && interventionStatus() !== 'Closed') {
    <div class="mt-6 flex justify-end border-t border-slate-200 pt-4">
      <button mat-stroked-button type="button" [disabled]="store.savingCia()" (click)="reopen()">Reopen for correction</button>
    </div>
  }
</mat-card>
